import React, { useEffect, useState } from "react";
import ExcelExport from "../../components/common/ui/Export/ExcelExport";
import Table from "../../components/common/table/Table";
import Button from "../../components/common/ui/Button";
import { history } from "../../_helpers";
import { useLocation } from "react-router-dom";
import { inmateAction, masterActions } from "../../_store";
import { useDispatch, useSelector } from "react-redux";
import ToggleSwitch from "../../components/common/ui/Inputs/ToggleSwitch";
import { showToastNotification } from "../../components/common/ui/NotificationModal/ToastNotication";
import CustomLoader from "../../components/common/ui/Loader";
import generateXlsx from "../../components/common/export/generateXlsx";
import { fDate } from "../../utils/formatTime";

function InmateConnectionRequest() {
  const location = useLocation();
  const { inmate: Inmate } = location.state || {};

  const {
    inmateInfoTabData,
    loading,
    connectionRequestList,
    connectionRequestFullList,
    connectionReqCount,
    InmateDNDResponse,
    inmate,
  } = useSelector((x) => x.inmate);

  const { user, commonFacilityCode: facilityCode } = useSelector((x) => x.auth);

  const dispatch = useDispatch();

  useEffect(() => {
    if (InmateDNDResponse?.IsSucceed === 1) {
      dispatch(inmateAction.GetInmateInvitePublicUserSearch(connectionReq));
      showToastNotification("Updated successfully.", "success");
      dispatch(inmateAction.clearInmateDNDResponse());
    }
  }, [InmateDNDResponse]);

  useEffect(() => {
    dispatch(
      masterActions.LoadFacilityDropDown({
        facilityID: 0,
        activeStatus: 1,
      })
    );
  }, [dispatch]);

  useEffect(() => {
    if (!Inmate?.InmateID && !inmate?.InmateID) return;

    let updatedParam = {
      ...connectionReq,
      InmatesId: Inmate?.InmateID || inmate?.InmateID,
      FacilityID: Inmate?.facilityID || inmate?.facilityID || facilityCode,
    };

    setConnectionReq(updatedParam);

    dispatch(inmateAction.GetInmateInvitePublicUserSearch(updatedParam));
    dispatch(
      inmateAction.GetLoadInmateInvitePublicCount({
        InmatesID: Inmate?.InmateID || inmate?.InmateID,
        facilityID: Inmate?.facilityID || inmate?.facilityID || facilityCode,
      })
    );
  }, []);

  const [connectionReq, setConnectionReq] = useState({
    InmatesId: 0,
    FacilityID: 0,
    PageNo: 1,
    RowCountPerPage: 10,
    SortField: "",
  });

  //column

  const columns = [
    {
      name: "Date",
      key: "InviteSentDate",
      selector: (row) => row.InviteSentDate,
      sortable: true,
    },
    {
      name: "Through",
      key: "InviteThrough",
      selector: (row) => row.InviteThrough,
      sortable: true,
    },
    {
      name: "First Name",
      key: "FirstName",
      selector: (row) => row.FirstName,
      sortable: true,
    },
    {
      name: "Last Name",
      key: "LastName",
      selector: (row) => row.LastName,
      sortable: true,
    },
    {
      name: "E-mail/Number",
      key: "ContactNumberOrEmail",
      selector: (row) => row.ContactNumberOrEmail,
      sortable: true,
    },
    {
      name: "Relationship",
      key: "RelationshipStatus",
      selector: (row) => row.RelationshipStatus,
      sortable: true,
    },
    {
      name: "Status",
      key: "InviteStatus",
      selector: (row) => row.SendInviteStatus,
      sortable: true,
    },
    ...(user?.UserRoleID !== 13
      ? [
        {
          name: "DND",
          key: "InmateDndStatus",
          selector: (row) => row.InmateDndStatus,
          sortable: true,
          cell: (row) => (
            <ToggleSwitch
              name={`Status${row.InmateID}`}
              id={`Status${row.InmateID}`}
              checked={row.InmateDndStatus === 1} // Simplified condition
              value={row.InmateDndStatus === 1 ? 1 : 0}
              handleClick={(e) => handleToggleSwitchChange(e, row)}
            />
          ),
        },
      ]
      : []),
  ];

  const handleToggleSwitchChange = (e, row) => {
    let checked = e.target.checked === true ? 1 : 0;

    dispatch(
      inmateAction.InmateDnd({
        inmateID: row?.InmateID,
        facilityID: Inmate?.facilityID || inmate?.facilityID || facilityCode,
        emailOrMobile: row?.MobileorEmail,
        // sourceName: row?.MobileorEmail,
        // newEmailOrMobile: row?.InviteThrough,
        sourceName: row?.InviteThrough,
        newEmailOrMobile: row?.MobileorEmail,
        remarks: "",
        dndStatus: checked,
        createdBy: user?.ManagementUserID,
      })
    );
  };

  //Pagination

  useEffect(() => {
    if (initialLoad) return;

    dispatch(inmateAction.GetInmateInvitePublicUserSearch(connectionReq));
  }, [connectionReq.PageNo, connectionReq.RowCountPerPage]);

  const [initialLoad, setInitialLoad] = useState(true);

  const handlePageChange = (pageNo) => {
    if (isSorting) {
      isSorting = false;
      return;
    }
    setInitialLoad(false);
    setConnectionReq((prev) => ({
      ...prev,
      PageNo: pageNo,
    }));
  };

  const handleRowPerPage = (rowCount) => {
    setInitialLoad(false);
    setConnectionReq((prev) => ({
      ...prev,
      RowCountPerPage: rowCount,
      PageNo: 1,
    }));
  };

  let isSorting = false;
  const handleSort = (column, sortDirection) => {
    if (!column?.key) return;
    isSorting = true;
    const search = { ...connectionReq };
    const newSortOrder = search.SortField.includes(column.key)
      ? search.SortField.endsWith("asc")
        ? "desc"
        : "asc"
      : "asc";

    search.SortField = `${column.key} ${newSortOrder}`;
    setConnectionReq(search);
    dispatch(
      inmateAction.GetInmateInvitePublicUserSearch({
        ...connectionReq,
        SortField: `${column.key} ${newSortOrder}`,
      })
    );
  };

  //Export

  useEffect(() => {
    if (
      connectionRequestFullList &&
      connectionRequestFullList?.DataList?.length > 0
    ) {
      let title = `Invites${fDate(new Date())}`;

      let generateExcelColumns = [
        "Date",
        "Through",
        "First Name",
        "Last Name",
        "Email/Number",
        "Relationship",
        "Status",
      ];

      // Map the account manager list to match the Excel format
      let Invites_List =
        connectionRequestFullList?.DataList?.map((obj) => ({
          Date: obj.InviteSentDate,
          InviteThrough: obj.InviteThrough,
          FirstName: obj.FirstName,
          LastName: obj.LastName,
          "Email/Number": obj.ContactNumberOrEmail,
          Relationship: obj.RelationshipStatus,
          Status: obj.SendInviteStatus,
        })) || [];

      try {
        // Generate the Excel file with the transformed data
        generateXlsx(Invites_List, generateExcelColumns, title);

        // Clear excel data after the download
        dispatch(inmateAction.clearconnectionRequestFullList());
      } catch (error) {
        // Handle any errors that occur during Excel generation
        console.error("Error generating Excel file:", error);
      }
    }
  }, [connectionRequestFullList]);

  const handleExcel = () => {
    let updatedParam = {
      ...connectionReq,
      PageNo: 1,
      RowCountPerPage: connectionRequestList?.TotalRecordCount,
      exportExcel: true,
    };

    dispatch(inmateAction.GetInmateInvitePublicUserSearch(updatedParam));
  };

  if (loading) {
    return <CustomLoader />;
  }
  return (
    <div>
      <div className="p-2 ">
        <div className="d-flex justify-content-between align-items-center ">
          <h4 className=" inner-subheader-bg text-color">
            <i className="fa fa-plug"></i> Connection Requests
          </h4>
          <Button
            label="Back"
            type="button"
            status="primary"
            className={"flex-shrink-0"}
            icon={"fa-solid fa-angle-left"}
            onClick={() => {
              history.navigate("/Admin/InmateList");
              dispatch(inmateAction.setInmateCurrentTab("inmate-info-tab"));
            }}
          />
        </div>
      </div>

      {/* First Row: Username, Last Name, First Name */}
      {connectionRequestList && connectionRequestList?.DataList?.length > 0 && (
        <div className="card shadow-sm b-r-all p-3 border border-dark-grey mt-1 w-100">
          <div className="row">
            {[
              {
                label: "Inmate Resident ID",
                value: Inmate?.InmateResidentId || inmate?.InmateResidentId,
              },
              {
                label: "Full Name",
                value:
                  Inmate?.InmateFullName ||
                  inmate?.InmateFullName ||
                  (inmateInfoTabData && inmateInfoTabData[0].InmateFullName),
              },
              {
                label: "Available Requests",
                value: connectionReqCount[0]?.InmateAvailbleCount,
              },
            ].map((item, index) => (
              <div key={index} className="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                <div className="user-information d-flex  align-items-center">
                  <div className="fs-5 p-2  value-info">{item.label}</div>
                  <div className="p-2">:</div>
                  <div className="fs-5 p-2 text-start fw-bold value-text">
                    {item.value || "-"}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="mt-3">
        <div className="d-flex flex-wrap  justify-content-end mb-3">
          {connectionRequestList &&
            connectionRequestList?.DataList?.length > 0 && (
              <ExcelExport
                variant="soft-gray"
                handleExcelExport={handleExcel}
              />
            )}
        </div>
        {/* Table Section */}

        <Table
          columns={columns}
          data={connectionRequestList?.DataList}
          pagination={true}
          onChangePage={(e) => handlePageChange(e)} // Call API when page changes
          onChangeRowsPerPage={(e) => handleRowPerPage(e)}
          totalRowCount={connectionRequestList?.TotalRecordCount}
          currentPage={connectionReq?.PageNo}
          paginationPerPage={connectionReq?.RowCountPerPage}
          onSort={handleSort}
          serverSideSort
          sortColumn={connectionReq?.SortField?.split(" ")[0]}
          sortDirection={connectionReq?.SortField?.split(" ")[1]}
        />
      </div>
    </div>
  );
}

export default React.memo(InmateConnectionRequest);
